import axios from "axios";
import i18next from 'i18next';
import BACKEND_URL from "../config";

const transport = axios.create({
    baseURL: BACKEND_URL
});

transport.interceptors.request.use((config) => {
    const lang = i18next.language || 'ar';
    config.headers['Accept-Language'] = lang;
    return config;
}, (error) => {
    return Promise.reject(error);
});

i18next.on('languageChanged', (lng) => {
    transport.defaults.headers['Accept-Language'] = lng;
});

export default transport;
